import api from '@/factories/api';

export default {
  state: {
    sidebarOpen: false,
    infoMessage: null,
    previousRoute: null,
    pageLoading: false,
    installAppPrompt: null,
    mobileBreakpoints: ['xs', 'sm'],
  },

  mutations: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    showInfoModal(state, message) {
      state.infoMessage = message;
    },
    setPreviousRoute(state, route) {
      if (!route.name) return;
      state.previousRoute = route;
    },
    setPageLoading(state, loading) {
      state.pageLoading = loading;
    },
    setInstallAppPrompt(state, promptEvent) {
      state.installAppPrompt = promptEvent;
    },
    setMobileBreakpoints: (state, val) => {
      state.mobileBreakpoints = val;
    },
  },

  actions: {
    async stringToTime({}, value) {
      let offset = '';
      let offsetMinutes = new Date().getTimezoneOffset();
      let hours = Math.floor(offsetMinutes / 60);
      let minutes = offsetMinutes - hours * 60;
      let operator = offsetMinutes > 0 ? '-' : '+';

      offset = [hours, minutes].filter((v) => v).join('');
      offset = offset ? `${operator}${offset}` : '';

      return api().post('helpers/strtotime', {
        value,
        offset,
      });
    },

    updateMobileBreakpoints: ({ commit }, breakpoints) => {
      commit('setMobileBreakpoints', breakpoints);
    },
  },

  getters: {
    sidebarOpen: (state) => {
      return state.sidebarOpen;
    },
    infoMessage(state) {
      return state.infoMessage;
    },
    previousRoute: (state) => {
      return state.previousRoute;
    },
    installAppPrompt: (state) => {
      return state.installAppPrompt;
    },
    mobileBreakpoints(state) {
      return state.mobileBreakpoints;
    },
  },
};
